import React, { useEffect, useState } from "react";
import "../styles/Carousel.css";

const Carousel = ({ object }) => {
  const [imgObject, setImgObjects] = useState([]);
  const [pictureCount, setPictureCount] = useState(0);

  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "https://www.casperetlulu.fr:3000",
      process.env.REACT_APP_API_URL,
    );
  };

  useEffect(() => {
    const pictures = object.pictures || [];

    const validPictures = pictures.filter(
      (picture) => picture && !picture.startsWith("blob:"),
    );

    setImgObjects([object.mainPicture, ...validPictures].filter(Boolean));
    setPictureCount(0);
  }, [object]);

  const imageSuivante = () => {
    const suivant = (pictureCount + 1) % imgObject.length;
    setPictureCount(suivant);
  };

  const imagePrecedente = () => {
    const precedent = (pictureCount - 1 + imgObject.length) % imgObject.length;
    setPictureCount(precedent);
  };
  const afficherNavigation = imgObject.length > 1;

  return (
    <div className="carousel">
      {afficherNavigation ? (
        <div className="carousel-controls">
          <button onClick={imagePrecedente}>{"<"}</button>
          <img
            src={fixImageUrl(imgObject[pictureCount])}
            className="carousel-image"
            alt={object.title}
          />
          <button onClick={imageSuivante}>{">"}</button>
        </div>
      ) : (
        <img
          src={fixImageUrl(imgObject[0])}
          className="carousel-image"
          alt={object.title}
        />
      )}
      <p className="count">
        {pictureCount + 1}/{imgObject.length}
      </p>
    </div>
  );
};

export default Carousel;
